import { render } from "./OnePost.html?vue&type=template&id=791599a7"
import script from "./OnePost.js?vue&type=script&lang=js"
export * from "./OnePost.js?vue&type=script&lang=js"

import exportComponent from "/home/nodejs/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__